import React from "react";
import { Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import clsx from "clsx";
import { TimeSlotType } from "../pages/types";

// TODO: check commented time because by now time is just a stirng not an object
const TimePicker = ({
  times,
  selectedTime,
  onSelectTime,
}: {
  times: TimeSlotType[];
  selectedTime: TimeSlotType | any;
  onSelectTime: (val: TimeSlotType) => void;
}) => {
  return (
    <div
      style={{
        maxHeight: "200px",
        overflowY: "auto",
      }}
    >
      {times.map((time: TimeSlotType) => (
        <div
          key={time.id}
          className={clsx({
            "time-container": true,
            selected: !!selectedTime && selectedTime.id === time.id,
            // disabled: !time.isAvailable,
          })}
          onClick={() => onSelectTime(time)}
        >
          <Typography variant={"body1"} component={"h2"}>
            {/* {time.description} */}
            {!!selectedTime && selectedTime.id === time.id && (
              <CheckCircleIcon style={{ float: "right" }} />
            )}
            {time.label}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default TimePicker;
